import React from 'react';
import { CompassIcon, ClockIcon, SunriseIcon, ActivityIcon, WavesIcon, MoonIcon, FeatherIcon, MessageCircleIcon, SlidersHorizontalIcon } from 'lucide-react';
import { SectionLabel } from './ui/SectionLabel';
import { CtaButton } from './ui/CtaButton';
const parts = [{
  icon: CompassIcon,
  label: 'Class Intention'
}, {
  icon: ClockIcon,
  label: 'Duration & Level'
}, {
  icon: SunriseIcon,
  label: 'Arrival & Centering'
}, {
  icon: ActivityIcon,
  label: 'Warm-Up'
}, {
  icon: WavesIcon,
  label: 'Main Sequence'
}, {
  icon: MoonIcon,
  label: 'Cooldown'
}, {
  icon: FeatherIcon,
  label: 'Savasana'
}, {
  icon: MessageCircleIcon,
  label: 'Teaching Cues'
}, {
  icon: SlidersHorizontalIcon,
  label: 'Modifications'
}];
export function ReadyToTeachSection() {
  return <section className="w-full bg-sand py-10 sm:py-14 lg:py-20" aria-labelledby="ready-heading" data-id="element-146" data-mp="1a4ifihcyrqj1">
      <div className="mx-auto w-full max-w-content px-5 sm:px-8" data-id="element-147" data-mp="163ewjlzmdedl">
        <div className="mx-auto max-w-2xl text-center" data-id="element-148" data-mp="1612jnn8pxu7e">
          <div className="flex justify-center" data-id="element-149" data-mp="31zgy89qj6jqw">
            <SectionLabel data-id="element-150" data-mp="31yo01x5n12kd">Inside every class</SectionLabel>
          </div>
          <h2 id="ready-heading" className="mt-3 font-serif text-[1.6rem] font-semibold uppercase leading-[1.08] text-ink sm:text-4xl" data-id="element-151" data-mp="36y0mwhwie9my">
            This is what <span className="text-forest" data-id="element-152" data-mp="3go3ce84f95gj">“Ready-to-Teach”</span> actually means.
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-[0.95rem] leading-snug text-muted sm:text-lg" data-id="element-153" data-mp="2j2pigaa76mrl">
            Each class gives you a complete teaching structure to review, adapt and teach.
          </p>
        </div>

        <ul className="mt-7 grid grid-cols-2 gap-2 sm:gap-3 lg:grid-cols-3" data-id="element-154" data-mp="2sy929ybhluzz">
          {parts.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center justify-center gap-2.5 rounded-2xl border border-sandDark bg-ivory px-3 py-3 text-center sm:px-4" data-id="element-155" data-mp="2xwkcia5p27iq">
              <Icon className="h-4 w-4 shrink-0 text-sage" aria-hidden="true" data-id="element-156" data-mp="daitj2xwrk7x" />
              <span className="text-[0.68rem] font-semibold uppercase leading-tight tracking-label text-ink sm:text-xs" data-id="element-157" data-mp="299zp3cs3p202">
                {label}
              </span>
            </li>)}
        </ul>

        <div className="mt-6 rounded-3xl bg-forest px-5 py-6 text-center sm:py-8" data-id="element-158" data-mp="2iaekx62oxzht">
          <p className="font-serif text-lg font-semibold uppercase leading-tight text-ivory sm:text-2xl" data-id="element-159" data-mp="2ebfc3adu9il3">
            The class is already structured.
            <span className="mt-1 block text-goldSoft" data-id="element-160" data-mp="1lmrtjmkh57b8">You bring the teaching.</span>
          </p>
          <p className="mt-3 font-serif text-[0.72rem] uppercase tracking-label text-ivory/70 sm:text-sm" data-id="element-161" data-mp="1ze6dbvm7hcjc">
            Open • Choose • Teach
          </p>
        </div>

        <div className="mt-6" data-id="element-162" data-mp="1ul3h1fq1nozg">
          <CtaButton label="Get the complete Yoga Teacher System™" microcopy="120 Complete Classes • Instant Access" data-id="element-163" data-mp="16wtz4ovybldl" />
        </div>
      </div>
    </section>;
}